class Permissions {
  public readonly content_area_view = "cms_content_area_view" as string;
  public readonly content_area_modify = "cms_content_area_modify" as string;
  public readonly content_area_create = "cms_content_area_create" as string;
  public readonly content_area_delete = "cms_content_area_delete" as string;
  public readonly subject_view = "cms_subject_view" as string;
  public readonly subject_modify = "cms_subject_modify" as string;
  public readonly subject_create = "cms_subject_create" as string;
  public readonly subject_delete = "cms_subject_delete" as string;
  public readonly domain_view = "cms_domain_view" as string;
  public readonly domain_modify = "cms_domain_modify" as string;
  public readonly domain_create = "cms_domain_create" as string;
  public readonly domain_delete = "cms_domain_delete" as string;
  public readonly standard_view = "cms_standard_view" as string;
  public readonly standard_modify = "cms_standard_modify" as string;
  public readonly standard_create = "cms_standard_create" as string;
  public readonly standard_delete = "cms_standard_delete" as string;
  public readonly standard_linking_view = "cms_standard_linking_view" as string;
  public readonly standard_linking_modify =
    "cms_standard_linking_modify" as string;
  public readonly standard_linking_create =
    "cms_standard_linking_create" as string;
  public readonly standard_linking_delete =
    "cms_standard_linking_delete" as string;
  public readonly standard_group_view = "cms_standard_group_view" as string;
  public readonly standard_group_modify = "cms_standard_group_modify" as string;
  public readonly standard_group_create = "cms_standard_group_create" as string;
  public readonly standard_group_delete = "cms_standard_group_delete" as string;
  public readonly subscription_view = "cms_subscription_view" as string;
  public readonly subscription_modify = "cms_subscription_modify" as string;
  public readonly subscription_create = "cms_subscription_create" as string;
  public readonly subscription_delete = "cms_subscription_delete" as string;
  public readonly clever_view = "cms_clever_view" as string;
  public readonly clever_modify = "cms_clever_modify" as string;
  public readonly clever_create = "cms_clever_create" as string;
  public readonly clever_delete = "cms_clever_delete" as string;
  public readonly class_link_view = "cms_class_link_view" as string;
  public readonly class_link_modify = "cms_class_link_modify" as string;
  public readonly class_link_create = "cms_class_link_create" as string;
  public readonly class_link_delete = "cms_class_link_delete" as string;
  public readonly district_view = "cms_district_view" as string;
  public readonly district_modify = "cms_district_modify" as string;
  public readonly district_create = "cms_district_create" as string;
  public readonly district_delete = "cms_district_delete" as string;
  public readonly school_view = "cms_school_view" as string;
  public readonly school_modify = "cms_school_modify" as string;
  public readonly school_create = "cms_school_create" as string;
  public readonly school_delete = "cms_school_delete" as string;
  public readonly user_view = "cms_user_view" as string;
  public readonly user_modify = "cms_user_modify" as string;
  public readonly user_create = "cms_user_create" as string;
  public readonly user_delete = "cms_user_delete" as string;
  public readonly nwea_view = "cms_nwea_view" as string;
  public readonly nwea_modify = "cms_nwea_modify" as string;
  public readonly nwea_create = "cms_nwea_create" as string;
  public readonly nwea_delete = "cms_nwea_delete" as string;
  public readonly question_view = "cms_question_view" as string;
  public readonly question_modify = "cms_question_modify" as string;
  public readonly question_create = "cms_question_create" as string;
  public readonly question_delete = "cms_question_delete" as string;
  public readonly supersheet_view = "cms_supersheet_view" as string;
  public readonly supersheet_modify = "cms_supersheet_modify" as string;
  public readonly supersheet_create = "cms_supersheet_create" as string;
  public readonly supersheet_delete = "cms_supersheet_delete" as string;
  public readonly teacher_questions_view =
    "cms_teacher_questions_view" as string;
  public readonly teacher_questions_modify =
    "cms_teacher_questions_modify" as string;
  public readonly teacher_questions_create =
    "cms_teacher_questions_create" as string;
  public readonly teacher_questions_delete =
    "cms_teacher_questions_delete" as string;
  public readonly passage_view = "cms_passage_view" as string;
  public readonly passage_modify = "cms_passage_modify" as string;
  public readonly passage_create = "cms_passage_create" as string;
  public readonly passage_delete = "cms_passage_delete" as string;
  public readonly grade_view = "cms_grade_view" as string;
  public readonly grade_modify = "cms_grade_modify" as string;
  public readonly grade_create = "cms_grade_create" as string;
  public readonly grade_delete = "cms_grade_delete" as string;
  public readonly tag_view = "cms_tag_view" as string;
  public readonly tag_modify = "cms_tag_modify" as string;
  public readonly tag_create = "cms_tag_create" as string;
  public readonly tag_delete = "cms_tag_delete" as string;
  public readonly worksheet_view = "cms_worksheet_view" as string;
  public readonly worksheet_modify = "cms_worksheet_modify" as string;
  public readonly worksheet_create = "cms_worksheet_create" as string;
  public readonly worksheet_delete = "cms_worksheet_delete" as string;
  public readonly video_view = "cms_video_view" as string;
  public readonly video_modify = "cms_video_modify" as string;
  public readonly video_create = "cms_video_create" as string;
  public readonly video_delete = "cms_video_delete" as string;
  public readonly slide_view = "cms_slide_view" as string;
  public readonly slide_modify = "cms_slide_modify" as string;
  public readonly slide_create = "cms_slide_create" as string;
  public readonly slide_delete = "cms_slide_delete" as string;
  public readonly lesson_plan_view = "cms_lesson_plan_view" as string;
  public readonly lesson_plan_modify = "cms_lesson_plan_modify" as string;
  public readonly lesson_plan_create = "cms_lesson_plan_create" as string;
  public readonly lesson_plan_delete = "cms_lesson_plan_delete" as string;
  public readonly learnosity_resubmit_view =
    "cms_learnosity_resubmit_view" as string;
  public readonly learnosity_resubmit_modifiy =
    "cms_learnosity_resubmit_modify" as string;
  public readonly skill_practice_subject_view =
    "cms_skill_practice_subject_view" as string;
  public readonly skill_practice_subject_modify =
    "cms_skill_practice_subject_modify" as string;
  public readonly skill_practice_subject_create =
    "cms_skill_practice_subject_create" as string;
  public readonly skill_practice_subject_delete =
    "cms_skill_practice_subject_delete" as string;
  public readonly skill_practice_standard_view =
    "cms_skill_practice_standard_view" as string;
  public readonly skill_practice_standard_modify =
    "cms_skill_practice_standard_modify" as string;
  public readonly skill_practice_standard_create =
    "cms_skill_practice_standard_create" as string;
  public readonly skill_practice_standard_delete =
    "cms_skill_practice_standard_delete" as string;
  public readonly skill_practice_question_view =
    "cms_skill_practice_question_view" as string;
  public readonly skill_practice_question_modify =
    "cms_skill_practice_question_modify" as string;
  public readonly skill_practice_question_create =
    "cms_skill_practice_question_create" as string;
  public readonly skill_practice_question_delete =
    "cms_skill_practice_question_delete" as string;
  public readonly nwea_rit_score_view = "cms_nwea_rit_score_view" as string;
  public readonly nwea_rit_score_modify = "cms_nwea_rit_score_modify" as string;
  public readonly nwea_rit_score_create = "cms_nwea_rit_score_create" as string;
  public readonly nwea_rit_score_delete = "cms_nwea_rit_score_delete" as string;
  public readonly nwea_header_mapping_view =
    "cms_nwea_header_mapping_view" as string;
  public readonly nwea_header_mapping_modify =
    "cms_nwea_header_mapping_modify" as string;
  public readonly nwea_header_mapping_create =
    "cms_nwea_header_mapping_create" as string;
  public readonly nwea_header_mapping_delete =
    "cms_nwea_header_mapping_delete" as string;
  public readonly canned_test_view = "cms_canned_test_view" as string;
  public readonly canned_test_modify = "cms_canned_test_modify" as string;
  public readonly canned_test_create = "cms_canned_test_create" as string;
  public readonly canned_test_delete = "cms_canned_test_delete" as string;
  public readonly sellable_product_view = "cms_sellable_product_view" as string;
  public readonly sellable_product_modify =
    "cms_sellable_product_modify" as string;
  public readonly sellable_product_create =
    "cms_sellable_product_create" as string;
  public readonly sellable_product_delete =
    "cms_sellable_product_delete" as string;
  public readonly bundle_view = "cms_bundle_view" as string;
  public readonly bundle_modify = "cms_bundle_modify" as string;
  public readonly bundle_create = "cms_bundle_create" as string;
  public readonly bundle_delete = "cms_bundle_delete" as string;
  public readonly permissions_view = "cms_permissions_view" as string;
  public readonly permissions_modify = "cms_permissions_modify" as string;
  public readonly permissions_create = "cms_permissions_create" as string;
  public readonly permissions_delete = "cms_permissions_delete" as string;
  public readonly permission_groups_view =
    "cms_permission_group_view" as string;
  public readonly permission_groups_modify =
    "cms_permission_group_modify" as string;
  public readonly permission_groups_create =
    "cms_permission_group_create" as string;
  public readonly permission_groups_delete =
    "cms_permission_group_delete" as string;
  public readonly user_permissions_view = "cms_user_permissions_view" as string;
  public readonly user_permissions_modify =
    "cms_user_permissions_modify" as string;
  public readonly user_permissions_create =
    "cms_user_permissions_create" as string;
  public readonly user_permissions_delete =
    "cms_user_permissions_delete" as string;
  public readonly galaxy_subjects_view =
    "cms_default_galaxy_subjects_view" as string;
  public readonly galaxy_subjects_modify =
    "cms_default_galaxy_subjects_modify" as string;
  public readonly galaxy_subjects_create =
    "cms_default_galaxy_subjects_create" as string;
  public readonly galaxy_subjects_delete =
    "cms_default_galaxy_subjects_delete" as string;
  public readonly mini_crm_view = "cms_mini_crm_view" as string;
  public readonly mini_crm_modify = "cms_mini_crm_modify" as string;
  public readonly mini_crm_create = "cms_mini_crm_create" as string;
  public readonly mini_crm_delete = "cms_mini_crm_delete" as string;
  public readonly crm_login_as_view = "crm_login_as_view" as string;
  public readonly crm_login_as_modify = "crm_login_as_modify" as string;
  public readonly crm_login_as_create = "crm_login_as_create" as string;
  public readonly crm_login_as_delete = "crm_login_as_delete" as string;
  public readonly crm_content_view = "crm_content_view" as string;
  public readonly crm_content_modify = "crm_content_modify" as string;
  public readonly crm_content_create = "crm_content_create" as string;
  public readonly crm_content_delete = "crm_content_delete" as string;
  public readonly crm_students_view = "crm_students_view" as string;
  public readonly crm_students_modify = "crm_students_modify" as string;
  public readonly crm_students_create = "crm_students_create" as string;
  public readonly crm_students_delete = "crm_students_delete" as string;
}

export default new Permissions();
